import { Dispatch } from "react";
import { react } from "uikit";

import Name from ".";

interface Context {
	name: Name.Value;
	setError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isValid = !!this.context?.name?.trim().length;

		if (!isValid) this.context?.setError(true);

		return isValid;
	}
}
